module.exports = __webpack_public_path__ + "img/cat2.615165bf.svg";